export enum ModalRefType {
  HOST = 'host',
  CHILD = 'child',
}
